import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";

const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

const enumToStringConverter = (value: string) => {
	if (!value) return "";
	return value
		.split("_")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
};

export const BenefitTypesColumns: ColumnDef<any>[] = [
	{
		accessorKey: "name",
		header: "Name",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "country",
		header: "Country",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => {
			const value = getValue() as any;
			return value ? value.name : "--";
		},
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 350,
		minSize: 250,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "code",
		header: "Code",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "benefitType",
		header: "Benefit Type",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => enumToStringConverter(getValue() as string),
	},
	{
		accessorKey: "terminal",
		header: "Terminal Benefit",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];
